<div class="transport-registration-document-scan">
    <div class="layout">
        <div class="left-column">
            <div class="column-layout">
                <div class="visual-area">
                    <div class="video-frame" [style.width.px]="resolution.width.ideal"
                        [style.height.px]="resolution.height.ideal" [style.transform]="previewTransform">
                        <!-- [style.transform]="previewTransform"-->
                        <video #video id="video" autoplay></video>
                    </div>
                </div>

                <button mat-fab color="primary" (click)="capture()" class="capture-button"><i
                        class="fa-light fa-camera"></i></button>

                <div class="hint">
                  <sc-dictionary-label dictionaryKey="tmc-yard.widgets.registration-terminal.transport-registration-document-scan.button-photo-hint"></sc-dictionary-label>
                </div>
            </div>
        </div>
        <div class="main-column">
            <app-centered-scrollable-content>
                <div class="column-layout">
                    <div class="image-container" *ngFor="let c of captures">
                        <app-tapable-terminal-card  (click)="openPreview(c)">
                            <img [src]="previewCapture(c)" class="capture" />
                        </app-tapable-terminal-card>
                    </div>
                </div>
            </app-centered-scrollable-content>
        </div>
        <canvas #canvas id="canvas" width="{{targetWidth}}" height="{{targetHeight}}" style="display: none"></canvas>
    </div>

</div>
